import { useState } from 'react';

export const useToast = () => {
  const [toast, setToast] = useState({ visible: false, message: '' });

  const showToast = (message, duration = 5000) => {
    setToast({ visible: true, message });
    setTimeout(() => {
      setToast({ visible: false, message: '' });
    }, duration);
  };

  const hideToast = () => {
    setToast({ visible: false, message: '' });
  };

  return { toast, showToast, hideToast };
};

export const checkNetworkError = (error) => {
  return (
    !navigator.onLine || 
    error.message?.toLowerCase().includes('network') || 
    error.message?.toLowerCase().includes('fetch') ||
    error.code === 'ERR_NETWORK' ||
    error.message?.toLowerCase().includes('failed to fetch')
  );
};
